import { Component, OnInit } from '@angular/core';
import { SMARTLABEL_HEADER } from '../../models/header/header';

export class SmartLabelTemplate {
 
  constructor() {
  }
}
